<template>
  <div class="dynamicindex">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>设备动态属性列表</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/dynamic/create')"
          >创建属性</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <!-- 类型下拉 -->
        <el-col :span="5">
          <el-select
            class="select"
            clearable
            v-model="deviceTypeValue"
            placeholder="请选择设备类型"
            @change="changeDeviceType"
          >
            <el-option
              v-for="item in deviceTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input
            placeholder="请输入属性名称"
            v-model="dynamicValue"
            clearable
            class="input-with-select"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="dictSearch"
            ></el-button>
          </el-input>
        </el-col>
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable :tableData="dynamicLists" :columns="columns" />
      <!-- 表格 -->

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <Edit
      :state="editState"
      @close="editState = false"
      :user="editUnit"
      @confirm="changeTool"
    />
    <!-- 编辑弹框 end -->
  </div>
</template>

<script>
import { dynamicList, deleteDynamic, updateDynamic } from '@/api/dynamic'
import { queryEquipment } from '@/api/dictionary'
import TzTable from '@/components/tz-table/Index.vue'
import Edit from './components/Edit'
export default {
  components: {
    TzTable,
    Edit
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      dynamicValue: '',
      deviceTypeValue: '',
      editState: false,
      editUnit: {},
      deviceTypeList: [], //设备类型下拉
      templateList: [], // 模板类型
      dynamicLists: [],
      columns: [
        {
          field: 'deviceType',
          title: '设备类型'
        },
        {
          field: 'templateType',
          title: '模板类型'
        },
        {
          field: 'attributeName',
          title: '属性名'
        },
        {
          field: 'attributeLabel',
          title: '属性标签'
        },
        {
          field: 'type',
          title: '是否必填'
        },
        {
          field: 'status',
          title: '状态'
        },
        {
          title: '操作',
          width: '160',
          type: 'btn',
          payload: [
            {
              name: '编辑',
              type: 'primary',
              click: (row) => {
                console.log('编辑', row)
                // this.editUnit = JSON.parse(JSON.stringify(row))
                let edirArr = JSON.parse(JSON.stringify(row))
                edirArr['status'] = edirArr['status'] === '启用' ? 1 : 2
                edirArr['type'] = edirArr['type'] === '否' ? 0 : 1
                this.editUnit = edirArr
                // 显示弹框
                this.editState = true
              }
            },
            {
              name: '删除',
              type: 'danger',
              click: (row) => {
                console.log('删除', row)
                this.deleteFn(row)
              }
            }
          ]
        }
      ]
    }
  },
  created() {
    this.queryEquipmentFn()
  },
  methods: {
    handleSizeChange(val) {
      this.size = val
      this.getDynamicList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getDynamicList()
    },
    //设备类型下拉
    changeDeviceType(value) {
      this.deviceTypeValue = value
      console.log(this.deviceTypeValue, '类型')
      // this.getWeightList()
    },
    //获取设备类型
    queryEquipmentFn() {
      let types = ['equipment_type', 'template_type']
      queryEquipment(types).then((res) => {
        console.log(res.data, '设备类型')
        this.deviceTypeList = res.data.equipment_type
        this.templateList = res.data.template_type
      })
    },
    // 列表
    getDynamicList() {
      let params = {
        attributeName: this.dynamicValue,
        deviceType: this.deviceTypeValue,
        pageSize: this.size,
        pageNum: this.page
      }
      dynamicList(params).then((res) => {
        if (res.code == 200) {
          let dynamicArr = res.data.records
          this.total = res.data.total
          this.dynamicLists = dynamicArr.map((item) => {
            return {
              id: item.id,
              attributeLabel: item.attributeLabel,
              deviceType: item.dictName_deviceType,
              templateType: item.dictName_templateType,
              attributeName: item.attributeName,
              status: Number(item.status) === 1 ? '启用' : '禁用',
              type: Number(item.type) === 0 ? '否' : '是'
            }
          })
        }
      })
    },

    // 编辑
    changeTool(infos) {
      console.log(infos)
      this.$loading({
        text: '属性更新中'
      })
      let devices = this.deviceTypeList.find(
        (el) => el.label === infos.deviceType
      )
      if (devices) infos.deviceType = devices.value
      let templates = this.templateList.find(
        (el) => el.label === infos.templateType
      )
      if (templates) infos.templateType = templates.value
      console.log(infos)

      let updateparams = {
        ...infos
      }
      updateDynamic(updateparams).then((res) => {
        console.log(res.data, '更新')
        this.$loading().close()
        if (res.code == 200) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getDynamicList()
        } else {
          this.$message({
            type: 'error',
            message: '更新失败!'
          })
        }
        this.editState = false
      })
    },
    // 删除
    deleteFn(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            id: row.id
          }
          deleteDynamic(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getDynamicList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 模糊查询
    dictSearch() {
      this.page = 1
      this.getDynamicList()
    }
  },
  mounted() {
    this.getDynamicList()
  }
}
</script>

<style></style>
